import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import useToast from 'hooks/useToast';

import API_ENDPOINTS from 'services/urls';
import { ICreateNoteRequest } from '../types';
import getCRMDealActivitiesInfiniteQueryOptions from '../Activity/hooks/useGetCRMDealActivities';

const createNote = async (postData: ICreateNoteRequest) => {
    const {
        organizationId, dealId, ...params
    } = postData;

    return axiosInstance.post(
        API_ENDPOINTS.CRM.DEAL_NOTES(organizationId, dealId),
        params,
    ).then(response => response.data);
};

const useCreateNote = () => {
    const { showSuccess, showError } = useToast();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createNote,
        onSuccess: (_, variables) => {
            showSuccess('Note created successfully');
            const queryOptions = getCRMDealActivitiesInfiniteQueryOptions(variables.organizationId, variables.dealId);
            queryClient.invalidateQueries(queryOptions);
        },
        onError: error => {
            showError('Failed to create note. Please try again.');
        },
    });
};

export default useCreateNote;
